import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../../util/util'


export const getInvoices = createAsyncThunk(
	'getInvoices',
	async payload => await envAwarePost(
		'api/financials/',
		{action:'getInvoices'}
	)
)

export const createInvoice = createAsyncThunk(
	'createInvoice',
	async payload => await envAwarePost(
		'api/financials',
		{action:'createInvoice',...payload}
	)
)

export const editInvoice = createAsyncThunk(
	'editInvoice',
	async payload => await envAwarePost(
		'api/financials',
		{action:'editInvoice',...payload}
	)
)


export const removeInvoice = createAsyncThunk(
	'removeInvoice',
	async id => await envAwarePost(
		'api/financials',
		{action:'removeInvoice',id}
	)
)

const invoicesAdapter = createEntityAdapter()

const slice = createSlice({
	name: 'payments',
	initialState : invoicesAdapter.getInitialState({
		status:'init',
		sort:{
			by:'date',
			order:'desc'
		},
		filter:{
			query:''
		},
		editor:{
			show:false,
			id:false
		}
	}),
	reducers : {
		setFilterQuery:(state,action)=>{
			state.filter.query = action.payload
		},
		setEditor:(state,action)=>{
			state.editor.show = action.payload.show
			state.editor.id = action.payload.id
		}
	},
	extraReducers : {
		[getInvoices.pending] : (state)=>{
			state.status = 'pending'
		},
		[getInvoices.fulfilled] : (state,action)=>{
			state.status = 'idle'
			invoicesAdapter.upsertMany(state,action.payload.data.invoices)
		},
		[createInvoice.fulfilled] : (state,action)=>{
			invoicesAdapter.upsertOne(state,action.payload.data.invoice)
		},
		[removeInvoice.pending] : (state,action)=>{
			invoicesAdapter.removeOne(state,action.meta.arg)
		},
		[editInvoice.fulfilled] : (state,action)=>{
			invoicesAdapter.upsertOne(state,action.payload.data.invoice)
		}
	}
})

export const {setEditor,setFilterQuery} = slice.actions

export const {
	selectAll: selectAllInvoices,
	selectById: selectInvoiceById,
	selectIds: selectInvoiceIds
} = invoicesAdapter.getSelectors( state => state.invoices )

export default slice.reducer